import { createRouter, createWebHistory } from "vue-router";

import Auth from "@/views/Auth.vue";
import Clients from "@/views/Clients.vue";
import Client from "@/views/Client.vue";
import NotFound from "@/views/NotFound.vue";
import ClientCreate from "@/views/ClientCreate.vue";

import checkToken from "@/middleware/checkToken.js"
import checkLogin from "@/middleware/checkLogin.js"

const routes = [
    {
        path: "/",
        name: "Main",
        redirect: "/clients",
        component: Client,
        beforeEnter: checkToken,
    },
    {
        path: "/login",
        name: "Login",
        component: Auth,
        beforeEnter: checkLogin,
    },
    {
        path: "/logout",
        name: "Logout",
    },
    {
        path: "/clients",
        name: "Клиенты",
        component: Clients,
        beforeEnter: checkToken,
    },
    {
        path: "/clients/client/:id",
        name: "Клиент",
        component: Client,
        beforeEnter: checkToken,
    },
    {
        path: "/clients/client/new",
        name: "Новый клиент",
        component: ClientCreate,
        beforeEnter: checkToken,
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: NotFound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

export default router;
